import gql from 'graphql-tag';
export const GET_AREAS_OF_INTERESTS = gql `
  query areasOfInterests($targetPersona: Personas!, $hostPersona: Personas) {
    areasOfInterests(hostPersona: $hostPersona, targetPersona: $targetPersona)
  }
`;
//# sourceMappingURL=areasOfInterests.js.map